// app/providers.tsx
"use client";
import {
  isPrivateCapabilityPath,
  isSharedBookingPath,
} from "@/lib/booking/sharedBooking";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { hasAutoSaveAdAttribution } from "@/lib/analytics/adAttribution";
import { captureWhatsAppLink } from "@/lib/whatsappLinkContext";

if (
  typeof window !== "undefined" &&
  !isSharedBookingPath(window.location.pathname)
) {
  captureWhatsAppLink();
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    capture_pageview: false,
    disable_session_recording: isPrivateCapabilityPath(
      window.location.pathname
    ),
    before_send: (event) =>
      isPrivateCapabilityPath(window.location.pathname) ? null : event,
    defaults: "2026-01-30",
  });
  // Set `platform` for flag evaluation immediately at init so it is sent on the
  // very first flags request for EVERY visitor, including anonymous and
  // logged-out users. Setting it only after login (see PostHogPageView) left
  // logged-out web users with no platform, so web-targeted flags resolved
  // false for them. Mobile sets platform to 'ios'/'android' in useAnalytics.ts.
  posthog.setPersonPropertiesForFlags({ platform: "web" });
  // Re-apply AutoSave-ad attribution on a hard reload: PostHogPageView sets this
  // when the visitor lands with an AutoSave utm_campaign, but a full reload
  // (after the utm has dropped off the URL) would otherwise lose it before the
  // first flags request. Persisted in localStorage; see adAttribution.ts.
  if (hasAutoSaveAdAttribution()) {
    posthog.setPersonPropertiesForFlags({ from_autosave_ad: true });
  }
}

export function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
